import { render, staticRenderFns } from "./CrRubikaDestination.vue?vue&type=template&id=ae6c2352&"
import script from "./CrRubikaDestination.vue?vue&type=script&lang=js&"
export * from "./CrRubikaDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports